import { render, staticRenderFns } from "./CenterChangePwd.vue?vue&type=template&id=1f0bc236&scoped=true&"
import script from "./CenterChangePwd.vue?vue&type=script&lang=js&"
export * from "./CenterChangePwd.vue?vue&type=script&lang=js&"
import style0 from "./CenterChangePwd.vue?vue&type=style&index=0&id=1f0bc236&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0bc236",
  null
  
)

export default component.exports